import {
    projectsSelector,
    groupsSelector,
    selectedProjectsSelector,
    selectedGroupsSelector,
    timePeriodsSelector
} from '../../../selectors/base';

import {
    summariesSelector,
    dataSelector,
    viewInfoSelector,
    filtersSelector,
    summarySelector,
    loadingSelector,
    excludedItemsSelector,
    timePeriodInfoSelector,
    environmentTypesSelector
} from './../../../selectors/deployment-frequency';

import { editModeSelector } from '../../../selectors/settings';

let lastEnvIds = [];

export default class DeploymentFrequencyController {
    static $inject = ['$ngRedux', 'DeploymentFrequencyActions', '$q', '$scope', '$element', 'widgetsHelper'];

    constructor($ngRedux, DeploymentFrequencyActions, $q, $scope, $element, widgetsHelper) {
        'ngInject';
        this.widgetsHelper = widgetsHelper;
        this.unsubscribe = $ngRedux.connect(mapStateToThis, DeploymentFrequencyActions)(this);
        this.onSummaryClick = this.onSummaryClick.bind(this);
        this.$q = $q;
        this.$scope = $scope;
        this.$element = $element;
        this.localEnviremntSaveOnSelectedEnv = [];
        this.customDate = { startDate: null, endDate: null };
        this.datePickerOptions = {
            eventHandlers: {
                'apply.daterangepicker': () => {
                    let localEnviremntSaveOnSelectedEnv = []
                    if (this.filters.graphType == 'ChartGroup') {
                        localEnviremntSaveOnSelectedEnv = this.localEnviremntSaveOnSelectedEnv;
                    }
                    const start = this.customDate.startDate.valueOf();
                    const end = this.customDate.endDate.valueOf();
                    const customPeriod = this.timePeriods.find(t => t.custom);
                    if (this.filters.graphType == 'ChartGroup') {
                        return this.loadSpecific(
                            { ...this.getLoadOptions(), timePeriod: customPeriod, start, end, environmentTypes: localEnviremntSaveOnSelectedEnv },
                            { summary: true, graph: true }
                        );
                    }
                    return this.loadSpecific(
                        { ...this.getLoadOptions(), timePeriod: customPeriod, start, end },
                        { summary: true, graph: true }
                    );
                }
            }
        }
    }

    environmentTypeSelected(select) {
        if (!select)
            return;
        const result = this.environmentTypes.filter(envType => envType.id == select.id)
        if (result.length == 0) {
            select = this.environmentTypes[0];
            this.onEnvSelected(select);
        }
        return select.name;
    }

    $onInit() {
        if (this.environmentTypes && this.environmentTypes.length > 0);
           lastEnvIds = [...this.environmentTypes];
        this.unwatchProjects = this.$scope.$watch(() => [...this.projectIds, ...this.groupIds], (newValues, oldValues) => {
            if (newValues !== oldValues) {
                this.loadSpecific(this.getLoadOptions(), { summary: true, graph: true });
            }
        }, true);
        this.loadSpecific(this.getLoadOptions(), { summary: true, graph: true });
        this.filters.environmentType = this.environmentTypeSelected(this.filters.environmentType);
        this.unwatchLegend = this.$scope.$watch(() => this.excludedItems, (newValues, oldValues) => {
            if (newValues !== oldValues) {
                this.loadSpecific(
                    { ...this.getLoadOptions(), ...this.widgetsHelper.filterLoadData(newValues, this.projects, this.groups) },
                    { graph: false, summary: true }
                );
            }
        }, true);
    }

    $onDestroy() {
        this.unwatchProjects();
        this.unsubscribe();
        this.unwatchLegend();
    }

    getLoadOptions(graphType) {
        let start, end;
        const graph = graphType || this.filters.graphType;
        const { timePeriod, environmentType } = this.filters;
        const { projectIds, groupIds, environmentTypes } = this;
        const { summaryProjectIds, summaryGroupIds } = this.widgetsHelper.filterLoadData(this.excludedItems, this.projects, this.groups);
        if (timePeriod.custom) {
            start = this.timePeriodInfo.start;
            end = this.timePeriodInfo.end;
        } else {
            end = Date.now();
            start = end - timePeriod.periodInMilliseconds;
        }
        let envTypes = this.hasSelectAll(graph === 'ChartGroup' ? environmentTypes : [environmentType]);
        return {
            timePeriod,
            environmentTypesDeploy: environmentTypes,
            environmentTypes: envTypes,
            graphType: graph,
            projectIds,
            groupIds,
            start,
            end,
            summaryProjectIds,
            summaryGroupIds
        };
    }

    hasSelectAll(envTypes) {
        const envSelectAll = _.find(envTypes, (type) => type.id == -1);
        if (envSelectAll && lastEnvIds.length > 0) {
            return lastEnvIds;
        }
        return envTypes
    }

    getEnvironmentTypes() {
        return this.environmentTypes.filter(type=> (type.name!=='DryRun'));
    }
    hasChanged(item) {
        return item.currentValue !== undefined && item.currentValue !== item.previousValue
    }

    onTimeSelected(timePeriod) {
        let localEnviremntSaveOnSelectedEnv = []
        if (this.filters.graphType == 'ChartGroup') {
            localEnviremntSaveOnSelectedEnv = this.localEnviremntSaveOnSelectedEnv;
        }
        if (timePeriod.custom) {
            this.$element.find('#deployment-frequency-datepicker').click();
        } else {
            if (this.filters.graphType == 'ChartGroup') {
                this.loadSpecific(
                    { ...this.getLoadOptions(), timePeriod, environmentTypes: localEnviremntSaveOnSelectedEnv },
                    { setEnvironmentType: this.filters.graphType !== 'ChartGroup', summary: true, graph: true }
                );
            } else {
                this.loadSpecific(
                    { ...this.getLoadOptions(), timePeriod },
                    { setEnvironmentType: this.filters.graphType !== 'ChartGroup', summary: true, graph: true }
                );
            }
        }
    }

    onEnvSelected(environmentType) {
        let environmentTypes = [environmentType];
        if (environmentType.selectAll) {
            environmentTypes = this.environmentTypes.splice(1)
        }
        this.loadSpecific(
            { ...this.getLoadOptions(), environmentTypes: environmentTypes },
            { setEnvironmentType: this.filters.graphType !== 'ChartGroup', summary: true, graph: true }
        );
    }

    onSummaryClick(summaryItem) {
        const index = this.summaries.indexOf(summaryItem);
        this.selectedSummaryChanged(index);
    }

    onGraphTypeChanged(graphType) {
        if ('ChartGroup' == graphType) {
            const { environmentTypes } = this;
            this.localEnviremntSaveOnSelectedEnv = environmentTypes.splice(1);
            this.loadSpecific(
                { ...this.getLoadOptions(graphType), environmentTypes: this.localEnviremntSaveOnSelectedEnv },
                { setEnvironmentType: graphType !== 'ChartGroup', summary: true, graph: true }
            );
        } else {
            if (this.localEnviremntSaveOnSelectedEnv.length > 0) {
                this.loadSpecific(
                    { ...this.getLoadOptions(graphType), environmentTypes: this.localEnviremntSaveOnSelectedEnv },
                    { setEnvironmentType: graphType !== 'ChartGroup', summary: true, graph: true }
                );
                this.localEnviremntSaveOnSelectedEnv = [];
            } else {
                this.loadSpecific(
                    this.getLoadOptions(graphType),
                    { setEnvironmentType: graphType !== 'ChartGroup', summary: true, graph: true }
                );
            }
        }
    }
}

function mapStateToThis(state) {
    const obj = {
        projects: projectsSelector(state),
        groups: groupsSelector(state),
        projectIds: selectedProjectsSelector(state),
        groupIds: selectedGroupsSelector(state),
        summaries: summariesSelector(state),
        dataset: dataSelector(state),
        environmentTypes: environmentTypesSelector(state),
        timePeriods: timePeriodsSelector(state),
        summary: summarySelector(state),
        viewInfo: viewInfoSelector(state),
        filters: filtersSelector(state),
        loading: loadingSelector(state),
        editMode: editModeSelector(state),
        excludedItems: excludedItemsSelector(state),
        timePeriodInfo: timePeriodInfoSelector(state)
    };
    return obj;
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/widgets/deployment-frequency/deployment-frequency.controller.js